import React from "react";

import { useLanguage } from "@/contexts/LanguageContext.jsx";
import LegalDocumentPage from "@/pages/legal/LegalDocumentPage.jsx";
import { getLegalEffectiveDate, getPrivacySections } from "@/pages/legal/legalContent.js";

export default function PrivacyPolicyPage() {
  const { t } = useLanguage();

  return (
    <LegalDocumentPage
      title={t("legal.privacy.title", "Privacy Policy")}
      subtitle={t(
        "legal.privacy.subtitle",
        "How AfriMed™ collects, uses, protects, and governs personal data across our telehealth platform.",
      )}
      effectiveDate={getLegalEffectiveDate(t)}
      sections={getPrivacySections(t)}
      siblingLink={{ to: "/legal/terms", label: t("common.legal.terms", "Terms & Conditions") }}
      extraLinks={[{ to: "/legal/data-deletion", label: t("common.legal.dataDeletion", "Data Deletion") }]}
    />
  );
}
